import { render, staticRenderFns } from "./DatasetFollowers.vue?vue&type=template&id=1f973b5f&scoped=true"
import script from "./DatasetFollowers.vue?vue&type=script&lang=js"
export * from "./DatasetFollowers.vue?vue&type=script&lang=js"
import style0 from "./DatasetFollowers.vue?vue&type=style&index=0&id=1f973b5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f973b5f",
  null
  
)

export default component.exports